import SharedSortableLists from "./SharedSortableLists";
import DigitalDesignerDigitalJobsIndex from "./DigitalDesignerDigitalJobsIndex";

export default class DigitalDesignerSortableDigitalJobsList extends SharedSortableLists {
  reactTableComponent() {
    return DigitalDesignerDigitalJobsIndex;
  }

  defaultSortKey() {
    return "due";
  }

  sortData() {
    // eslint-disable-next-line
    switch (this.sortKey) {
      case "due":
        return this.sortBy({ attr: "post_due_in" });
      case "due_at":
        return this.sortMulti([
          { attr: "due_at_raw", reverseNever: true },
          { attr: "client_name" },
          { attr: "index" },
        ]);
      case "client_name":
        return this.sortMulti([
          { attr: "client_name" },
          { attr: "due_at_raw", reverseNever: true },
          { attr: "index" },
        ]);
    }

    // For linter
    return null;
  }
}
